<mat-divider [style.border-top]="borderTopStyle"></mat-divider>
